import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {
  FormInput,
  FormInputText,
  Button
} from 'camino-react'

const SelectAnswer = ({
  onChange,
  questionIndex,
  removeAnswerOption,
  addAnswerOption,
  question,
  errors
}) => {
  const inputs = _.map(question.answers, (answer, index) => (
    <FormInput>
      <div key="noticeItem.id" className="flex flex--centered flex--space-between Select__wrapper-with-padding">

        <div className="flex--grow">
          <FormInputText
            value={answer}
            onValue={value => onChange(questionIndex, value, index)}
            errors={errors}
          />
        </div>
        {_.size(question.answers) > 1 && (
          <Button
            onClick={() => removeAnswerOption(questionIndex, index)}
            size="compact"
            color="danger"
          >
          Remove
          </Button>
        )}
      </div>
    </FormInput>
  ))

  return (
    <>
      <br />
      <FormInput label="Answer options">
        {inputs}
        <br />
        <Button
          outline
          size="compact"
          onClick={() => { addAnswerOption(questionIndex) }}
        >
        Add answer
        </Button>
      </FormInput>
    </>
  )
}

const RangeAnswer = ({
  onChange,
  questionIndex
}) => (
  <>
    <br />
    <FormInput label="Answers selection between">
      <div key="noticeItem.id" className="flex flex--centered flex--space-between Select__wrapper-with-padding">
        <div className="flex--grow form-input-text">
          <input
            className="form-input-text__input"
            onChange={event => onChange(questionIndex, event.target.value, 0)}
            type="number"
            name="answer_range"
            min="1"
            max="20"
          />
        </div>
        <div className="flex--grow form-input-text">
          <input
            className="form-input-text__input"
            onChange={event => onChange(questionIndex, event.target.value, 1)}
            type="number"
            name="answer_range"
            min="1"
            max="20"
          />
        </div>
      </div>
    </FormInput>
  </>
)

class AssociatedAnswers extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      multiselectCount: 0,
      singleselectCount: 0
    }
  }

  render () {
    const {
      question,
      onAnswerChange,
      questionIndex,
      errors,
      removeAnswerOption,
      addAnswerOption
    } = this.props
    const { multiselectCount, singleselectCount } = this.state

    const answers = () => {
      switch (question.question_type) {
        case 'multiselect':
          return (
            <SelectAnswer
              count={multiselectCount}
              onChange={onAnswerChange}
              questionIndex={questionIndex}
              removeAnswerOption={removeAnswerOption}
              addAnswerOption={addAnswerOption}
              question={question}
            />
          )
        case 'singleselect':
          return (
            <SelectAnswer
              count={singleselectCount}
              onChange={onAnswerChange}
              questionIndex={questionIndex}
              removeAnswerOption={removeAnswerOption}
              addAnswerOption={addAnswerOption}
              question={question}
              errors={errors}
            />
          )
        case 'text':
          return (null)
        case 'range':
          return (
            <RangeAnswer
              onChange={onAnswerChange}
              questionIndex={questionIndex}
              errors={errors}
            />
          )
        default:
          return (null)
      }
    }

    return (answers())
  }
}

AssociatedAnswers.propTypes = {
  question: PropTypes.shape({}).isRequired,
  onAnswerChange: PropTypes.func.isRequired,
  questionIndex: PropTypes.number.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string)
}

AssociatedAnswers.defaultProps = {
  errors: []
}

export default AssociatedAnswers
